import { gtmDataLayerPush, type GtmEventNames } from '../../gtm'

const TRACKING_VARIANT_A = 0
const TRACKING_VARIANT_B = 1
const TRACKING_VARIANT_C = 2

const getTrackingVariant = (trackingToken?: string | null): number | null => {
  const trackingTokenParts = trackingToken?.split('|') ?? []

  if (trackingTokenParts.includes('A')) {
    return TRACKING_VARIANT_A
  }

  if (trackingTokenParts.includes('B')) {
    return TRACKING_VARIANT_B
  }

  if (trackingTokenParts.includes('C')) {
    return TRACKING_VARIANT_C
  }

  return null
}

export const gtmDataLayerPushRecommendationTracking = ({
  event = 'crosssellWidgetData',
  trackingToken,
  widgetId,
  widgetProductId,
}: {
  event?: Extract<GtmEventNames, 'crosssell_a2c' | 'crosssellWidgetData'>
  productId?: string | null
  trackingToken?: string | null
  widgetId?: string
  widgetProductId?: string
}): void => {
  const emcs5 = getTrackingVariant(trackingToken)

  gtmDataLayerPush({
    emcs0: widgetId,
    emcs1: trackingToken,
    emcs3: widgetProductId,
    emcs5,
    event,
  })
}
